<div [id]="id()" data-uitype="map-container" class="w-full h-full relative px-4">
    @if (!isMapLoaded()) {
    <div
        class="absolute top-0 bottom-0 left-0 right-0 animate-pulse bg-dat-grey-300"
    ></div>
    }
    <div
        [class.opacity-0]="!isMapLoaded()"
        data-uitype="map"
        class="w-full bg-white h-[300px]"
    ></div>
    <div
        class="w-full flex flex-row justify-between pt-4 pr-3"
        [id]="id() + '-map-legend'"
        [attr.data-testid]="id() + '-map-legend'"
        [attr.data-uitype]="'map-legend'"
        [attr.data-styletarget]="id() + '-map-legend'"
    >
        <div
            class="font-caption text-dat-grey-900"
            [id]="id() + '-map-legend-timeType'"
            [attr.data-testid]="id() + '-map-legend-timeType'"
            [attr.data-uitype]="'map-legend-timeType'"
            [attr.data-styletarget]="id() + '-map-legend-timeType'"
        >
            {{ timeFrame() }}
        </div>
        <div class="flex flex-col" id="legend">
            <div
                class="flex flex-row space-x-0.5"
                [id]="id() + '-map-legend-gauge'"
                [attr.data-testid]="id() + '-map-legend-gauge'"
                [attr.data-uitype]="'map-legend-gauge'"
                [attr.data-styletarget]="id() + '-map-legend-gauge'"
                *ngIf="!!mapGaugeLegend()"
            >
                <ng-container
                    *ngFor="
                        let color of mapGaugeLegend()?.colors;
                        first as first;
                        last as last
                    "
                >
                    <span
                        *ngIf="first"
                        class="w-[32px] h-[3px] rounded-l-md border-r border-solid border-white"
                        [style.background]="color"
                    >
                    </span>
                    <span
                        *ngIf="!first && !last"
                        class="w-[32px] h-[3px] border-r border-solid border-white"
                        [style.background]="color"
                    >
                    </span>
                    <span
                        *ngIf="last"
                        class="w-[32px] h-[3px] rounded-r-md border-solid border-white"
                        [style.background]="color"
                    >
                    </span>
                </ng-container>
            </div>

            <div
                class="flex flex-row justify-between mt-0.5 p-0 ml-[-10px] w-[110%]"
            >
                <ng-container *ngFor="let rangeVal of mapGaugeLegend()?.range">
                    <span class="text-[10px]">{{ rangeVal }}</span>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<!-- @if(!errors()){
    @if (loaded()) {
        <section [attr.data-styletarget]="id() + '-container'" class="w-full h-full px-4">
            <div class="w-full h-full iq-mc-map-dashboard--map"
                [id]="id()"
                [attr.data-testid]="id() + '-map'"
                [attr.data-uitype]="'map'"
                [attr.data-styletarget]="id() + '-map'"
                #map>
            </div>
            <div class="w-full flex flex-row justify-between mt-4 pr-3"
                [id]="id() + '-map-legend'"
                [attr.data-testid]="id() + '-map-legend'"
                [attr.data-uitype]="'map-legend'"
                [attr.data-styletarget]="id() + '-map-legend'">

                <div class="font-caption text-dat-grey-900"
                    [id]="id() + '-map-legend-timeType'"
                    [attr.data-testid]="id() + '-map-legend-timeType'"
                    [attr.data-uitype]="'map-legend-timeType'"
                    [attr.data-styletarget]="id() + '-map-legend-timeType'">
                    Prior 30 Days
                </div>
                <div class="flex flex-col"
                    id="legend">

                    <div class="flex flex-row space-x-0.5"
                        [id]="id() + '-map-legend-gauge'"
                        [attr.data-testid]="id() + '-map-legend-gauge'"
                        [attr.data-uitype]="'map-legend-gauge'"
                        [attr.data-styletarget]="id() + '-map-legend-gauge'"
                        *ngIf="!!mapGaugeLegend()">
                        <ng-container
                            *ngFor="let color of mapGaugeLegend().colors; first as first; last as last">

                            <span *ngIf="first"
                                class="w-[32px] h-[3px] rounded-l-md border-r border-solid border-white "
                                [style.background]="color">
                            </span>
                            <span *ngIf="!first && !last"
                                class="w-[32px] h-[3px] border-r border-solid border-white "
                                [style.background]="color">
                            </span>
                            <span *ngIf="last"
                                class="w-[32px] h-[3px] rounded-r-md border-solid border-white"
                                [style.background]="color">
                            </span>
                        </ng-container>
                    </div>

                    <div class="flex flex-row  justify-between mt-0.5 p-0 ml-[-10px] w-[110%]">
                        <ng-container *ngFor="let rangeVal of mapGaugeLegend().range;">
                            <span class="text-[10px]">{{rangeVal}}</span>
                        </ng-container>
                    </div>

                </div>
            </div>
        </section>
    }
    @else {
        <div class="w-full h-full px-4 bg-dat-grey-200 animate-pulse">
        </div>
        }
        }
@else{
        <div class="w-full h-full">
            <datiq-screen-error>
                <div datiq-screen-error-message-title [attr.data-testid]="id() + '-error-title'">
                    Outbound Market Conditions Index is currently unavailable.
                </div>
                <div datiq-screen-error-message-content [attr.data-testid]="id() + '-error-content'">
                    Refresh or try again later.
                </div>
            </datiq-screen-error>
        </div>
}


 -->
